import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { dayToJSDate } from '@shared/dates'
import format from 'date-fns/format'
import { Fragment } from 'react'

export interface TRequestDate {
  startDate: string
  endDate: string
  startTime?: string | null
  endTime?: string | null
}

export interface TReceiptInvoice {
  displayName: string
  id: string
  invoiceStatus: string
  invoiceSubStatus: string
  isInStay: boolean
  items: {
    locationServiceType: GenericSimpleBag
    priceVaries: boolean
    subtotal: string
    taxLabel: string
    title: string
  }
  name: string
  pets: string[]
  requestPeriods: TRequestDate[]
  serviceTypeName: string
  subtotal: string
}

const RequestDate = ({ requestDates }: { requestDates: TRequestDate[] }) => {
  return requestDates.map((requestDate, idx) => {
    let date = dayToJSDate(requestDate.startDate)
    let hasTime = false
    if (!date) return null
    if (requestDate.startTime) {
      date = new Date(`${requestDate.startDate}T${requestDate.startTime}`)
      hasTime = true
    }
    return (
      <Fragment key={requestDate.startDate}>
        <Typography variant="body1" component="span">
          {format(date, hasTime ? 'MMM dd, h:mm aa' : 'MMM dd')}
        </Typography>
        {requestDates.length > 0 && idx < requestDates.length - 1 && <span>,&nbsp;</span>}
      </Fragment>
    )
  })
}

export const RequestDates = ({ invoices }: { invoices: TReceiptInvoice[] }) => {
  if (!invoices || invoices.length === 0 || invoices.every((i) => !i.requestPeriods || i.requestPeriods.length === 0)) {
    return null
  }

  return (
    <Box pt={3} ml={1}>
      <Typography variant="h6">Request Dates</Typography>
      <Box py={1}>
        {invoices.map((invoice) => {
          if (!invoice.requestPeriods || invoice.requestPeriods.length === 0) {
            return null
          }
          return (
            <Box key={invoice.id} mb={1}>
              <RequestDate requestDates={invoice.requestPeriods} /> ({invoice.pets.join(', ')})
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
